<template>
  <div class="container">
    <div class="containers">
      <img src="../assets/developing.png" alt="" />
      <p>页面正在建设中...</p>
    </div>
    <Foot />
  </div>
</template>

<script>
import Foot from "./Foot.vue";
export default {
  name: "",
  components: { Foot },
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.container {
  width: 100%;
  height: calc(100% - 83px);
  overflow: hidden;
  //   display: flex;
  //   flex-direction: column;
  //   justify-content: center;
  //   align-items: center;
  // padding: 20px 0;
  .containers {
    width: 80%;
    height: calc(100% - 200px);
    margin: 60px auto;
    // height: calc(100% - 100px);
    // margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background: #fff;
    padding-top: 100px;
    box-sizing: border-box;
  }
  img {
    background-size: 100%;
  }
  p{
    line-height: 50px;
    font-size: 18px;
    color: #5780F2;
  }
  // img{
  //     width: 100%;
  //     height: 100%;
  //     background-size: 100% 100%;
  // }
}
</style>
